module.exports = __webpack_public_path__ + "static/img-hidden-plans@2x-4cb1a3e639679ba8fdba55bb2d5b1a73.png";